"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constant = require("../../styles/constant");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
const Wrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  line-height: ", ";\n  font-size: ", ";\n"])), (0, _constant.get)('lineHeights.20'), (0, _constant.get)('fontSizes.14'));
const Title = _styledComponents["default"].span(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n"])), (0, _constant.get)('colors.primary.blue.600'));
const Item = _styledComponents["default"].span(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: pointer;\n  &:last-child {\n    .seperator {\n      display: none;\n    }\n    .isNotShortened {\n      cursor: default;\n    }\n    .title {\n      color: ", ";\n    }\n  }\n"])), (0, _constant.get)('colors.functional.grey.600'));
const Seperator = _styledComponents["default"].span(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: 0 ", ";\n"])), (0, _constant.get)('space.4'));
const Components = exports.Components = {
  Wrapper,
  Seperator,
  Item,
  Title
};